import React from 'react';

import { TrashIcon, ArrowUpIcon, ArrowDownIcon, DuplicateIcon } from "@heroicons/react/outline";
import Dropdown from "UI/Dropdown";
import Feature from "Components/Feature";

export default function SlideActions({ slide, moveSlide, removeSlide, duplicateSlide, selectSlide })
{
    return <Dropdown button={Dropdown.VerticalDotsButton} origin='tl'>
        <Dropdown.Item onClick={() => moveSlide(slide.id, slide.position - 1)}>
            <ArrowUpIcon className='inline mr-1 w-4' /> Move Up
        </Dropdown.Item>
        <Dropdown.Item onClick={() => moveSlide(slide.id, slide.position + 1)}>
            <ArrowDownIcon className='inline mr-1 w-4' /> Move Down
        </Dropdown.Item>
        <Dropdown.Item onClick={() => duplicateSlide(slide.id).then(slide => selectSlide(slide.id))}>
            <DuplicateIcon className='inline mr-1 w-4' /> Duplicate
        </Dropdown.Item>
        <Dropdown.Item danger onClick={() => removeSlide(slide.id)}>
            <TrashIcon className='inline mr-1 w-4' /> Delete
        </Dropdown.Item>
    </Dropdown>;
}
